import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useCallback, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Breadcrumbs, I18N, Loader } from '@/components';
import { useSnackbar } from '@/contexts/SnackbarContext';
import { OwnerForm } from '@/forms';
import { ApiException, useApi } from '@/hooks/useApi';
const OwnerCreationPage = () => {
    const navigate = useNavigate();
    const { callApi } = useApi();
    const { showError, showSuccess } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const handleSubmit = useCallback(async (data) => {
        setLoading(true);
        try {
            const createData = {
                hubspotId: data.hubspotId,
                name: data.name,
                notes: data.notes || undefined,
                canCreateCompanies: data.canCreateCompanies,
                canCreateLicenses: data.canCreateLicenses,
                canProvisionEgressSeats: data.canProvisionEgressSeats,
                maxTotalLicenses: data.maxTotalLicenses,
                maxTotalSeats: data.maxTotalSeats,
                maxSeatsPerLicense: data.maxSeatsPerLicense,
                licenseValidityLength: data.licenseValidityLength,
            };
            const response = await callApi('POST', '/owners', createData);
            if (response && typeof response === 'object' && 'id' in response) {
                showSuccess('Owner created successfully!');
                navigate(`/owners/${response.id}`, { replace: true });
            }
        }
        catch (e) {
            const detail = e instanceof ApiException && e.detail;
            showError(detail || 'Failed to create owner');
        }
        finally {
            setLoading(false);
        }
    }, [callApi, navigate, showError, showSuccess]);
    return (_jsxs(Box, { className: "p-2 md:max-w-[800px] mx-auto", children: [_jsxs(Breadcrumbs, { children: [_jsx(Link, { replace: true, to: "/owners", children: _jsx(I18N, { children: "navigation.owners" }) }), _jsx(Link, { replace: true, to: "/owners/new", children: _jsx(I18N, { children: "common.new" }) })] }), _jsx(OwnerForm, { defaultValues: {
                    hubspotId: '',
                    name: '',
                    notes: '',
                    canCreateCompanies: false,
                    canCreateLicenses: false,
                    canProvisionEgressSeats: false,
                    maxTotalLicenses: null,
                    maxTotalSeats: null,
                    maxSeatsPerLicense: null,
                    licenseValidityLength: 5,
                }, onSubmit: handleSubmit, onCancel: () => navigate('/owners', { replace: true }), submitting: loading, mode: "onChange", children: _jsx(I18N, { children: "owners.newOwner" }) }), _jsx(Loader, { loading: loading })] }));
};
export default OwnerCreationPage;
